import app from 'app';
import templateUrl from './summary.html';
import moment from 'moment';
import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-circle-plus';
import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-circle-minus';

import './summary.scss';
import { logEvent, eventCategories } from 'helpers/analytics';

// 2020-01-01
function getYear(dateString) {
  return dateString.split('-')[0];
}

function getDisplayYear(sponsorshipPeriod) {
  /**
   * TODO: Investigate sponsorshipPeriods which span multiple years
   * PR: https://github.com/collectivehealth/frontend-web-member/pull/245
   *
   * Handling for a range of years was in place prior to the react migration
   * However, we cannot produce a test user with a sponsorshipPeriod that starts
   * in one year and ends in another. There also does not appear to be an
   * instance of this in production based on what backend has communicated.
   * Because of this, we're leaving a comment for consideration as the react
   * migration project continues.
   */

  // sponsorshipPeriod will have started in the current year or earlier
  const curYear = moment().year();
  const startYear = moment(sponsorshipPeriod.startDate).year();

  return startYear === curYear ? startYear : `${startYear}-${curYear}`;
}

function SummaryCtrl(Claims, AccumulatorsService, $stateParams) {
  const Summary = this;

  Summary.transformAccumulatorType = type => {
    if (type === 'DEDUCTIBLE') {
      return 'Deductible';
    } else {
      return 'Out-of-Pocket Maximum';
    }
  };

  Summary.toggleSpendingVisibility = () => {
    Summary.spendingVisible = !Summary.spendingVisible;
  };

  Summary.$onInit = () => {
    Summary.patientId = $stateParams.patientId;
    Summary.showFamily = Summary.patientId === 0;
    Summary.hasAccumulators = false;
    Summary.displayYear = getDisplayYear(Summary.sponsorshipPeriod);

    AccumulatorsService.getAccumulators(Summary.currentSponsorship.id).then(
      accumulators => {
        const { coveredMembers, familyAccumulators } = accumulators;

        if (coveredMembers.length > 1) {
          Summary.familyAccumulators = familyAccumulators;

          Summary.familyAccumulatorsByNetworkType = {};
          Summary.familyAccumulators.forEach(accumulator => {
            if (
              Summary.familyAccumulatorsByNetworkType[accumulator.networkType]
            ) {
              Summary.familyAccumulatorsByNetworkType[
                accumulator.networkType
              ].push(accumulator);
            } else {
              Summary.familyAccumulatorsByNetworkType[
                accumulator.networkType
              ] = [accumulator];
            }
          });

          Summary.hasAccumulators =
            Summary.familyAccumulators && Summary.familyAccumulators.length > 0;
        }

        if (coveredMembers.length === 1) {
          Summary.individualAccumulators = coveredMembers[0].accumulators;
          Summary.showFamily = false;
          Summary.selectedUserName = coveredMembers[0].firstName;
        } else if (Summary.patientId !== 0) {
          Summary.individual = coveredMembers.find(member => {
            return member.id === Summary.patientId;
          });
          Summary.individualAccumulators = Summary.individual.accumulators;
          Summary.selectedUserName = Summary.individual.firstName;
        }

        Summary.hasAccumulators =
          Summary.hasAccumulators ||
          (Summary.individualAccumulators &&
            Summary.individualAccumulators.length > 0);

        Summary.individualAccumulatorsByNetworkType = {};
        Summary.individualAccumulators.forEach(accumulator => {
          if (
            Summary.individualAccumulatorsByNetworkType[accumulator.networkType]
          ) {
            Summary.individualAccumulatorsByNetworkType[
              accumulator.networkType
            ].push(accumulator);
          } else {
            Summary.individualAccumulatorsByNetworkType[
              accumulator.networkType
            ] = [accumulator];
          }
        });
      }
    );

    const patientIdParam =
      Summary.patientId !== 0 ? Summary.patientId : undefined;

    if (Summary.hasDental) {
      Claims.getPlanPaid({
        personId: Summary.currentUser.user.id,
        sponsorship: Summary.currentSponsorship,
        planType: 'DENTAL',
        patientId: patientIdParam,
        sponsorshipPeriod: Summary.sponsorshipPeriod
      }).then(planPaid => {
        Summary.dentalSpending = planPaid.planPaid;
        Summary.dentalLoaded = true;
      });
    }

    if (Summary.hasVision) {
      Claims.getPlanPaid({
        personId: Summary.currentUser.user.id,
        sponsorship: Summary.currentSponsorship,
        planType: 'VISION',
        patientId: patientIdParam,
        sponsorshipPeriod: Summary.sponsorshipPeriod
      }).then(planPaid => {
        Summary.visionSpending = planPaid.planPaid;
        Summary.visionLoaded = true;
      });
    }
  };

  Summary.submitClaimClicked = () => {
    logEvent('submitClaimButtonClicked', {
      category: eventCategories.MSOON
    });
  };
}

app.component('summary', {
  bindings: {
    hasDental: '<',
    hasVision: '<',
    currentUser: '<',
    currentSponsorship: '<',
    sponsorshipPeriod: '<'
  },
  controller: SummaryCtrl,
  controllerAs: 'Summary',
  templateUrl
});

export default 'summary';
